import { jsonldAcceptedPaymentMethods } from './JsonldStore';

export const updateJsonldAcceptedPaymentMethods = (value) => jsonldAcceptedPaymentMethods.update((oldValue) => value);
